export enum SchemaType {
	Stock,
	MobileWatch,
	FullDWatch,
	Portfolio,
	Screener,
	MarketDepth,
	MarketDepthPopUp,
	LastTradeInfo,
	LastTradeInfoPopUp,
	OrderState,
	SymbolInfo,
	IndInst,
	Index,
	AskBidPrices,
	OrderPlace,
	BestOfMarket,
	marketAffecting,
	Conditional,
	SearchSchema,
	DesktopPortfolio,
	DesktopRealtimePortfolio,
	ReturnSchema,
	EasyFilterSchema,
	EasyFilterIndInstSchema,
	dMarketWatch,
	MarketWatch,
	MarketViewTopRank
}

export enum ConnectionState {
	NotConnected = 0,
	Connecting = 1,
	Connected = 2,
	Disconnected = 3,
	Unknown = 4
}

export interface ILsData {
	inst: string;
	pos?: number;
	val?: string | any;
	name?: string;
	fullData?: any;
	subId?: string;
}
export interface ILsMarketDepthData {
	isr: string;
	type?: string;
	orderId?: string;
	timestamp?: string;
	state?: string;
}
export interface IMoney {
	customerIsin: string;
	credit: number;
	buyPower: number;
	block: number;
	timestamp: string;
}

export interface ILsMoney {
	customerIsin: string;
	credit: string;
	buyPower: string;
	mtsBlock: string;
	tbsBlock: string;
	block: string;
	timestamp: string;
	T2: string;
}

export enum OrderMessageType {
	OrderEvent = 'OrderEvent',
	OrderError = 'OrderError',
	OrderResult = 'OrderResult',
	Trade = 'Trade',
	TradeCancellation = 'TradeCancellation',
	OrderElimination = 'OrderElimination',
	SupervisorTrade = 'SupervisorTrade'
}
export interface IDesktopItemChange {
	isin: string;
	paramName: string;
	value: string;
}
export interface IDesktopQuantityChange {
	isin: string;
	quantity: number;
}
export interface IRealTimeDesktopQuantityChange {
	isin: string;
	// quantity: number;
	asset?: number;
	buysMinusSellsAsset?: number;
}
export interface IDesktopOrderInGridChange {
	id: string;
	paramName: string;
}

export type ILsTimeData = ILsData;

export interface ISubscriptionModel {
	mode?: string;
	items?: string[];
	schema?: string[];
	adaptername?: string;
	issnapshot?: string;
	schemaType?: SchemaType;
	isin?: string;
	changeType?: SubscriptionChangeType;
}

export const enum OmsSide {
	Buy = 65,
	Sell = 86
}
export enum SubscriptionChangeType {
	Field = 0,
	Full = 1
}
export enum SubscriptionMode {
	Raw = 'RAW',
	Merge = 'MERGE'
}
export enum SubscriptionIsSnapshot {
	Yes = 'yes',
	No = 'no'
}

export const enum LsAdapterNames {
	RlcAdapter = 'RLC_ADAPTER',
	SleAdapter = 'SLE_ADAPTER',
	BestLimitAdapter = 'BESTLIMIT_ADAPTER',
	MarketSheetAdapter = 'MARKETSHEET_ADAPTER',
	ThirdPartyAdapter = 'THIRDPARTY_ADAPTER'
}
export enum LsSchemaType {
	BestLimit = 1,
	Symbol,
	DMarketWatch,
	SymbolHeader,
	MarketDepthSymbol,
	OrderFormAskOrBid,
	StockInfo,
	OrderForm,
	EasyFilter,
	MarketWatch,
	Search,
	RecentSearch,
	Portfolio,
	RealtimePortfolio,
	Conditional,
	MarketAffecting,
	BestOfMarket,
	ReturnChart,
	DPortfolio,
	DRealtimePortfolio,
	TradeVolume,
	EasyFilterIndInst,
	GroupStateChange,
	TextMessage,
	Money,
	Order,
	OrderPlace,
	Index,
	MarketSheet,
	MarketSheetChartBuy,
	MarketSheetChartSell,
	TodayActivity,
	ActiveStock,
	MarketViewTopRank,
	SameGroup,
	Performance,
	PerformanceDetail,
	AlgoParent,
	PerformanceRecalculate,
	MtsCommand,
	OptionMarketView,
	BlackScholesCalculator,
	OptionPosition,
	ContractInfo,
	OptionContract,
	OptionCustomerStatus,
	OptionBaseSymbolInfo
}

export const enum LsTopics {
	BestLimit = 'bestlimit',
	Symbol = 'symbol',
	TradeVolume = 'tradevolume',
	GroupStateChange = 'groupstatechange',
	TextMessage = 'textmessage',
	Money = 'money',
	Order = 'order',
	OrderPlace = 'orderplace',
	Index = 'index',
	MarketSheet = 'marketsheet',
	MarketSheetChartBuy = 'marketsheet-details-buy',
	MarketSheetChartSell = 'marketsheet-details-sell',
	Performance = 'performance',
	PerformanceDetail = 'performancedetail',
	AlgoParent = 'algoparent',
	PerformanceRecalculate = 'performancerecalculate',
	MtsCommand = 'mts-command',
	OptionPosition = 'option-position',
	OptionContract = 'option-contract',
	OptionCustomerStatus = 'option-customer-status'
}

export const enum MTSCommandType {
	PortfolioRecalculation = 1
}
